// used for airport locations - used in individual session
export enum SupportedAirports {
  LHR = 0,
  LGW = 1,
  LTN = 2,
  MAN = 3,
  GVA = 4
}
